import React, { useContext, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Store } from 'react-notifications-component';
import { Context } from '../../index';
import { servicesHideRemove } from '../../../../../../services/endpoints/services';
import { removeService, removeError, removeSuccess } from '../../reducer';
import { useTbodyPosition } from '../../../../../../utils/hooks/useTbodyPosition';
import { getErrorMessage } from '../../../../../../utils/helper';

const Body = ({ items, isLoading }) => {
  // eslint-disable-next-line
  const [state, dispatch] = useContext(Context);
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: items?.length, bodyHeight: '300px' });
  const onRemove = async (id) => {
    if (id) {
      dispatch(removeService(id))

      try {
        await servicesHideRemove(id);
        dispatch(removeSuccess())
      } catch (error) {
        const errorMessage = getErrorMessage(error);
        Store.addNotification({
          title: 'Error',
          message: errorMessage,
          type: 'danger',
          insert: 'top',
          container: 'bottom-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
          },
        });
        dispatch(removeError())
      }
    }
  }

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: '50%' }}
      ref={bodyRef}
    >
      {items.map((item) => (
        <tr
          key={`hider-service-${item.id}`}
        >
          <td className="p-l">{item.id}</td>
          <td className="hide-services-table__service">{item.title}</td>
          <td className="p-r text-right">
            <Button
              disabled={isLoading}
              onClick={() => onRemove(item.id)}
              bsSize="xsmall"
            >
              Remove
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

Body.defaultProps = {
  items: [],
};

Body.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  // eslint-disable-next-line
  config: PropTypes.object,
};

export default Body;
